export const ValidationErrorType = {
    LENGTH: 'length_error',
    NAME_EXISTS: 'name_exists',
    TOO_MANY_COLLECTIONS: 'too_many_collections',
    TOO_MANY_ITEMS: 'too_many_items'
};
